import { useEffect } from "react";
import { trackEvent } from "../lib/analytics";

export default function useTimeOnPage() {
  useEffect(() => {
    const startTime = Date.now();

    const sendTimeEvent = () => {
      const durationSeconds = Math.max(
        1,
        Math.round((Date.now() - startTime) / 1000)
      );

      trackEvent("time_on_page", { durationSeconds });
    };

    const handleBeforeUnload = () => {
      sendTimeEvent();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        sendTimeEvent();
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      sendTimeEvent();
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
}